export default function CampaignChannelSelector({ value, onChange }) {

  return (
    <div>
      <h4>Channel</h4>

      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="push">Push Notification</option>
        <option value="in_app">In-App</option>
        <option value="email">Email</option>
        <option value="sms">SMS</option>
        <option value="whatsapp">WhatsApp</option>
      </select>
    </div>
  );
}
